/* istanbul ignore file */
import { CreatePageLayout } from 'framework/ui/layout';
import { CreateForm } from 'framework/form';
import { useExpenseService, useExpenseUrl } from 'domain/shared/expense';
import CreateExpenseBreadcrumbs from 'domain/finance/expenses/createupdate/Create/Breadcrumbs';
import ExpenseForm from 'domain/finance/expenses/createupdate/ExpenseForm';
import { useSearchParameters } from 'framework/routing';
import { useDateService, DATE_FORMAT } from 'framework/utils';

const CreateExpensePage = () => {
  const { create, getValidationSchema } = useExpenseService();
  const { getSingleEntityUrl } = useExpenseUrl();
  const { employeeAlias, employeeName, leaveId, subtype, type, title, registrationDate } = useSearchParameters();
  const { formatDate, getToday } = useDateService();

  return (
    <CreateForm
      submitFormFunc={create}
      afterSubmit={{
        redirect: ({ id }) => getSingleEntityUrl(id),
        message: 'You are awesome! The Worker Expense has been successfully created.',
      }}
      getValidationSchemaFunc={getValidationSchema}
      initialData={{
        compensation: { currency: 'USD' },
        employeeAlias,
        employeeName: employeeName ? `${employeeAlias} ${employeeName}` : null,
        leaveId,
        subtype,
        type,
        title,
        registrationDate: registrationDate || formatDate(getToday(), DATE_FORMAT.INPUT_VALUE)?.trim(),
      }}
    >
      <CreatePageLayout breadcrumbs={<CreateExpenseBreadcrumbs />} title="Create: Worker Expense">
        <ExpenseForm />
      </CreatePageLayout>
    </CreateForm>
  );
};

export default CreateExpensePage;
